export const evaluationQuestions = [
  {
    key: "jobKnowledge",
    title: "Work Quality & Accuracy",
    description:
      "Demonstrate attention to detail, accurate and reliable to complete the given task.",
    weight: "(Rate out 20 marks)",
    formName: "jobUnderstandingRating",
    commentName: "jobUnderstandingComment",
  },
  {
    key: "collaboration",
    title: "Teamwork & Collaboration",
    description:
      "Works effectively with colleagues, shares knowledge, supports team members, maintains positive working relationships, and contributes to achieving team objectives.",
    weight: "(Rate out 15 marks)",
    formName: "collaborationRating",
    commentName: "collaborationComment",
  },
  {
    key: "communication",
    title: "Communication Skills",
    description:
      "Communicates information clearly and professionally through verbal, written, and interpersonal interactions. Demonstrates active listening and ensures effective coordination.",
    weight: "(Rate out 15 marks)",
    formName: "communicationSkillsRating",
    commentName: "communicationSkillsComment",
  },
  {
    key: "performance",
    title: "Initiative & Problem Solving",
    description:
      "Identifies issues proactively, takes ownership of tasks, suggests improvements, and develops practical solutions to challenges.",
    weight: "(Rate out 20 marks)",
    formName: "performanceRating",
    commentName: "performanceComment",
  },
  {
    key: "punctuality",
    title: "Discipline & Attendance",
    description:
      "Demonstrates punctuality, regular attendance, adherence to company policies, professional conduct, and responsible use of organizational resources and time.",
    weight: "(Rate out 15 marks)",
    formName: "attendanceRating",
    commentName: "attendanceComment",
  },
  {
    key: "jobSkills",
    title: "Planning & Organization",
    description:
      "Effectively prioritizes work, manages time and resources, and meets deadlines while maintaining quality standards.",
    weight: "(Rate out 15 marks)",
    formName: "jobSkillsRating",
    commentName: "jobSkillsComment",
  },
];
